import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from '../contexts/NotificationContext';
import { useIdleTimeout } from '../hooks/useIdleTimeout';

/**
 * Auto-disconnects an authenticated user after a period of inactivity.
 *
 * Self-gates on isAuthenticated, so it can be mounted unconditionally at the
 * App level. Renders nothing.
 */
export default function IdleTimer() {
  const { isAuthenticated, logout } = useAuth();
  const { showToast } = useNotifications();

  const onIdle = useCallback(() => {
    // Toast first so it's queued before navigation; NotificationProvider sits
    // above the router, so the message survives the redirect to /login.
    showToast('Session expirée par inactivité', 'warning');
    logout();
  }, [showToast, logout]);

  useIdleTimeout({ isActive: isAuthenticated, onIdle });

  return null;
}
